<template>
  <v-card class="d-flex align-center my-0 pa-0 py-2 px-0 pb-0" elevation="0">
    <div style="width: 100%">
      <v-card-title class="card-title pl-0">
        <v-icon v-if="arrow" class="pr-1" @click="voltar" color="#BC0000"
          >mdi-arrow-left</v-icon
        >
        <b :style="!arrow ? 'margin-left: 15px' : ''"> {{ title }}</b>
      </v-card-title>
      <v-card-text  class="card-text">{{ text }} </v-card-text>
    </div>
  </v-card>
</template>

<style scoped>
.card-title {
  font-family: Roboto;
  font-size: 1.5rem !important;
}

.card-text {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 300;
  line-height: 30px;
  width: 100%;
  color: #9c9c9c;
}
.v-btn {
  font-weight: bold;
  width: 250px;
  border-radius: 10px;
  height: 50px;
}

.config {
  background-color: #ffffff !important;
  border: 1px solid #2d3038 !important;
  box-sizing: border-box;
  border-radius: 10px;
  height: 50px;
}

@media (max-width: 900px) {
  .card-title {
    font-family: Roboto;
    font-size: 2rem;
    padding: 0;
  }

  .card-text {
    font-size: 1rem;
    width: 80%;
  }
}
</style>

<script>
export default {
  name: "HeaderCard",

  data: () => ({}),
  props: {
    arrow: Boolean,
    title: String,
    text: String,
    actionTitle: String,
    haveAction: Boolean,
    mainPage: Boolean,
  },

  methods: {
    action() {
      this.$emit("action");
    },

    action2() {
      this.$emit("action2");
    },

    action3() {
      this.$emit("action3");
    },

    voltar() {
      this.$emit("voltar");
    },
  },
};
</script>
